import { createRouter, createWebHistory } from 'vue-router'
import { store } from './store.js'

// routers
const router = createRouter({
  history: createWebHistory(),
  routes: [
    // 官网
    {
      name:'LawView',
      meta:{title:"刑事法汇"},
      path: '/',
      component: () => import('@/views/home/LawHome.vue')
    },
    // 账号
    {
      name:'AccountView',
      meta:{title:"账号"},
      path:'/account',
      redirect:'/account/login',
      children:[
        {
          name:'AccountLogin',
          meta:{title:"账号登录"},
          path:'/account/login',
          component: () => import('@/views/account/AccountLogin.vue')
        },
        {
          name:'AccountRegister',
          meta:{title:"账号注册"},
          path:'/account/register',
          component: () => import('@/views/account/AccountRegister.vue')
        },
        {
          name:'AccountForget',
          meta:{title:"忘记密码"},
          path:'/account/forget',
          component: () => import('@/views/account/AccountForget.vue')
        }
      ]
    },
    // 用户端
    {
      name:'UserView',
      meta:{title:"刑事法汇"},
      path:'/my',
      component: () => import('@/views/user/UserView.vue'),
      beforeEnter: (to, from,next) => {
        let user = store.getUser();
        let token = store.getToken();
        if (token && user && user.roles.includes('user')) {
          let expireDate = new Date(user.expireTime);
          let currentDate = new Date();
          if(currentDate > expireDate && to.name != 'UserProfile'){
            next({ name: 'UserProfile' });
          }else{
            next();
          }
        }else {
          window.location.href="/account/login?f=" + encodeURIComponent('/my');
        }
      },
      children:[
        {
          name:'UserHomeView',
          meta:{title:"系统主页"},
          path:'/my',
          redirect:'/my/profile',
          component: () => import('@/views/user/home/HomeView.vue'),
          children:[
            {
              name:'UserProfile',
              meta:{title:"我的账号"},
              path:'/my/profile',
              component: () => import('@/views/user/home/UserProfile.vue')
            }
          ]
        },
        {
          name:'XFView',
          meta:{title:"刑法法规"},
          path:'/my/xf',
          component: () => import('@/views/user/law/xf/XFView.vue'),
          children:[
            {
              name:'XFHome',
              meta:{title:"刑法"},
              path:'/my/xf',
              component: () => import('@/views/user/law/xf/XFHome.vue')
            },
            {
              name:'XFData',
              meta:{title:"刑法法规"},
              path:'/my/xf/data',
              component: () => import('@/views/user/law/xf/XFData.vue')
            }
          ]
        },
        {
          name:'XSFView',
          meta:{title:"刑诉法规"},
          path:'/my/xsf',
          component: () => import('@/views/user/law/xsf/XSFView.vue'),
          children:[
            {
              name:'XSFHome',
              meta:{title:"刑事诉讼法"},
              path:'/my/xsf',
              component: () => import('@/views/user/law/xsf/XSFHome.vue')
            },
            {
              name:'XSFData',
              meta:{title:"刑诉法规"},
              path:'/my/xsf/data',
              component: () => import('@/views/user/law/xsf/XSFData.vue')
            }
          ]
        },
        {
          name:'JCFView',
          meta:{title:"监察法规"},
          path:'/my/jcf',
          component: () => import('@/views/user/law/jcf/JCFView.vue'),
          children:[
            {
              name:'JCFHome',
              meta:{title:"监察法"},
              path:'/my/jcf',
              component: () => import('@/views/user/law/jcf/JCFHome.vue')
            },
            {
              name:'JCFData',
              meta:{title:"监察法规"},
              path:'/my/jcf/data',
              component: () => import('@/views/user/law/jcf/JCFData.vue')
            }
          ]
        },
        {
          name:'JDGFView',
          meta:{title:"鉴定规范"},
          path:'/my/jdgf',
          component: () => import('@/views/user/law/jdgf/JDGFView.vue'),
          children:[
            {
              name:'JDGFData',
              meta:{title:"鉴定规范"},
              path:'/my/jdgf',
              component: () => import('@/views/user/law/jdgf/JDGFData.vue')
            }
          ]
        },
        {
          name:'WDView',
          meta:{title:"问答精选"},
          path:'/my/wd',
          component: () => import('@/views/user/law/wd/WDView.vue'),
          children:[
            {
              name:'WDData',
              meta:{title:"问答精选"},
              path:'/my/wd',
              component: () => import('@/views/user/law/wd/WDData.vue')
            }
          ]
        },
        {
          name:'DFFView',
          meta:{title:"地方法规"},
          path:'/my/dff',
          component: () => import('@/views/user/law/dff/DFFView.vue'),
          children:[
            {
              name:'DFFData',
              meta:{title:"地方法规"},
              path:'/my/dff',
              component: () => import('@/views/user/law/dff/DFFData.vue')
            }
          ]
        }
      ]
    },
    // 管理端
    {
      name:'AdminView',
      meta:{title:"刑事法汇"},
      path:'/admin',
      component: () => import('@/views/admin/AdminView.vue'),
      beforeEnter: (to, from,next) => {
        let user = store.getUser();
        let token = store.getToken();
        if (token && user && user.roles.includes('admin')) {
          let expireDate = new Date(user.expireTime);
          let currentDate = new Date();
          if(currentDate > expireDate && to.name != 'AdminProfile'){
            next({ name: 'AdminProfile' });
          }else{
            next();
          }
        }else {
          window.location.href="/account/login?f=" + encodeURIComponent('/admin');
        }
      },
      children:[
        {
          name:'AdminHomeView',
          meta:{title:"系统主页"},
          path:'/admin',
          component: () => import('@/views/admin/home/HomeView.vue'),
          children:[
            {
              name:'AdminHome',
              meta:{title:"系统主页"},
              path:'/admin',
              component: () => import('@/views/admin/home/AdminHome.vue')
            },
            {
              name:'AdminProfile',
              meta:{title:"我的账号"},
              path:'/admin/profile',
              component: () => import('@/views/admin/home/AdminProfile.vue')
            }
          ]
        },
        {
          name:'AdminUser',
          meta:{title:"用户资料"},
          path:'/admin/user',
          component: () => import('@/views/admin/user/UserView.vue'),
          children:[
            {
              name:'AdminUserHome',
              meta:{title:"用户资料"},
              path:'/admin/user',
              component: () => import('@/views/admin/user/UserHome.vue')
            }
          ]
        },
        {
          name:'AdminOrgan',
          meta:{title:"机构资料"},
          path:'/admin/organ',
          component: () => import('@/views/admin/organ/OrganView.vue'),
          children:[
            {
              name:'AdminOrganHome',
              meta:{title:"机构资料"},
              path:'/admin/organ',
              component: () => import('@/views/admin/organ/OrganHome.vue')
            }
          ]
        },
        {
          name:'AdminClause',
          meta:{title:"律法资料"},
          path:'/admin/law/clause',
          component: () => import('@/views/admin/law/clause/ClauseView.vue'),
          children:[
            {
              name:'AdminClauseHome',
              meta:{title:"律法资料"},
              path:'/admin/law/clause',
              component: () => import('@/views/admin/law/clause/ClauseHome.vue')
            },
            {
              name:'AdminClauseLabel',
              meta:{title:"律法标签",label:"clause"},
              path:'/admin/law/clause/label',
              component: () => import('@/views/admin/law/label/LabelHome.vue')
            }
          ]
        },
        {
          name:'AdminQues',
          meta:{title:"问答资料"},
          path:'/admin/law/ques',
          component: () => import('@/views/admin/law/ques/QuesView.vue'),
          children:[
            {
              name:'AdminQuesHome',
              meta:{title:"问答资料"},
              path:'/admin/law/ques',
              component: () => import('@/views/admin/law/ques/QuesHome.vue')
            },
            {
              name:'AdminQuesLabel',
              meta:{title:"问答标签",label:"ques"},
              path:'/admin/law/ques/label',
              component: () => import('@/views/admin/law/label/LabelHome.vue')
            }
          ]
        },
        {
          name:'AdminCase',
          meta:{title:"案例资料"},
          path:'/admin/law/case',
          component: () => import('@/views/admin/law/case/CaseView.vue'),
          children:[
            {
              name:'AdminCaseHome',
              meta:{title:"案例资料"},
              path:'/admin/law/case',
              component: () => import('@/views/admin/law/case/CaseHome.vue')
            },
            {
              name:'AdminCaseLabel',
              meta:{title:"案例标签",label:"case"},
              path:'/admin/law/case/label',
              component: () => import('@/views/admin/law/label/LabelHome.vue')
            }
          ]
        },
        {
          name:'AdminRefer',
          meta:{title:"关联资料"},
          path:'/admin/law/refer/xf',
          component: () => import('@/views/admin/law/refer/ReferView.vue'),
          children:[
            {
              name:'AdminXFHome',
              meta:{title:"刑法"},
              path:'/admin/law/refer/xf',
              component: () => import('@/views/admin/law/refer/ReferXFHome.vue')
            },
            {
              name:'AdminXSFHome',
              meta:{title:"刑事诉讼法"},
              path:'/admin/law/refer/xsf',
              component: () => import('@/views/admin/law/refer/ReferXSFHome.vue')
            },
            {
              name:'AdminJCFHome',
              meta:{title:"监察法"},
              path:'/admin/law/refer/jcf',
              component: () => import('@/views/admin/law/refer/ReferJCFHome.vue')
            }
          ]
        },
        {
          name:'AdminPay',
          meta:{title:"订阅资料"},
          path:'/admin/pay/order',
          component: () => import('@/views/admin/pay/PayView.vue'),
          children:[
            {
              name:'AdminPayOrder',
              meta:{title:"付款订单"},
              path:'/admin/pay/order',
              component: () => import('@/views/admin/pay/PayOrder.vue')
            },
            {
              name:'AdminPayRule',
              meta:{title:"订阅规则"},
              path:'/admin/pay/rule',
              component: () => import('@/views/admin/pay/PayRule.vue')
            }
          ]
        }
      ]
    }
  ]
})

export default router